<template>
  <div class="mt-4">
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      :row-key="getRowKey"
      border
      @selection-change="handleSelectionChange"
      header-row-class-name="thead-light table-th-color"
    >
      <el-table-column type="selection" width="70" :reserve-selection="true">
      </el-table-column>
      <el-table-column label="Name" width="120">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column property="mobile" width="180" label="Phone Number">
      </el-table-column>
      <el-table-column property="email" label="Email" show-overflow-tooltip>
      </el-table-column>
    </el-table>

    <div class="flex justify-end mt-4">
      <!-- <el-pagination background layout="prev, pager, next" :total="40">
      </el-pagination> -->
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getAllUsers();
          }
        "
        :per-size="perPage"
        :total="totalUsers"
      ></el-pagination>
    </div>
    <div class="flex mt-6 justify-end gap-3">
      <div class="relative">
        <vs-button
          @click="userAdd"
          variant="primary"
          class="rounded-lg bg-primary border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
        >
          Submit
        </vs-button>
      </div>
      <div class="relative">
        <vs-button
          @click="cancelUser"
          type="secondary"
          class="rounded-lg bg-secondary border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
        >
          Cancel
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
export default {
  data() {
    return {
      segmentData: [],
      tableData: [],
      multipleSelection: [],
      totalUsers: 0,
      currentPage: 1,
      perPage: 10,
      value: [],
    };
  },
  props: { search: { type: String, default: "" } },
  watch: {
    search: debounce(async function () {
      this.getAllUsers(this.search);
    }),
  },
  methods: {
    getRowKey(row) {
      // console.log(row);
      return row._id;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    cancelUser() {
      this.$emit("handleCreateSegmentPopup");
    },
    userAdd() {
      this.$emit("segments", this.multipleSelection);
      this.$emit("handleCreateSegmentPopup");
      // this.$refs.multipleTable.clearSelection();
      // console.log(this.multipleSelection);
    },
    async getAllSegments() {
      try {
        let data = await this.$store.dispatch("segment/getAllSegment");
        this.segmentData = data.data;
        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    async getAllUsers(value) {
      try {
        let payload = {
          perPage: this.perPage,
          page: this.currentPage,
        };
        if (value) {
          Object.assign(payload, { name: value });
        }
        console.log("payload", payload);
        let data = await this.$store.dispatch("user/getAllUsers", payload);
        this.tableData = data.registeredUser;
        this.totalUsers = data.registeredUserLength;
        // if (this.multipleSelection.length != 0) {
        //   for (let i = 0; i < this.multipleSelection.length; i++) {
        //     // this.members = this.multipleSelection;
        //     this.members.push(this.multipleSelection[i]);
        //   }
        // }
        // if (this.members.length != 0) {
        //   for (let i = 0; i < this.members.length; i++) {
        //     if (this.members[i]._id == this.tableData[i]._id) {
        //       console.log(this.members[i]._id);
        //       console.log(this.tableData[i]._id);
        //       this.value.push(this.members[i]);
        //     }
        //   }
        // }
        // if (this.value.length != 0) {
        //   this.handleSelectionChange(this.value);
        // }
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    this.getAllSegments();
    this.getAllUsers();
  },
};
</script>
